'use client'
import styled, { keyframes } from 'styled-components'

// Definimos la animación hue-rotate
export const hueAnimationBackground = keyframes`
  0% {
    filter: hue-rotate(0deg);   /* Inicia en tono normal */
  }
  50% {
    filter: hue-rotate(90deg);  /* Pasa a un tono verde */
  }
  100% {
    filter: hue-rotate(0deg);   /* Vuelve al tono normal */
  }
`

export const BackgroundCenter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: 100vh;
    width: 100%;
    background-color: #0d1117;
    background: rgb(6, 43, 5);
    z-index: 2;
    background: radial-gradient(
        circle,
        rgba(6, 43, 5, 1) 0%,
        rgba(13, 17, 23, 1) 70%
    );
    animation: ${hueAnimationBackground} 5s linear infinite; /* Animación en loop */
`

export const BackgroundPageLayout = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 100vh;
    width: 100%;
    background: transparent;
    gap: 10px;
`

export const AnimatedBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: radial-gradient(
        circle,
        ${({ theme }) => theme.bg || 'rgba(6, 43, 5, 1)'} 0%,
        rgba(13, 17, 23, 1) 80%
    );
    animation: ${hueAnimationBackground} 5s linear infinite;
    pointer-events: none;
`

export const BackgroundTop = styled.div`
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: 100vh;
    width: 100vw;
    background-color: #0d1117;
    background: rgb(6, 43, 5);
    background: radial-gradient(
        circle,
        rgba(6, 43, 5, 1) 0%,
        rgba(13, 17, 23, 1) 50%
    );
    animation: ${hueAnimationBackground} 5s linear infinite; /* Animación en loop */
    padding-top: 100px;
`
